import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Subtitle2 from '../../common/typographys/Subtitle2';
import TimeBox from '../../configs/pieces/TimeBox';
import ListPointsCheckbox from './ListPointsCheckbox';
import { MeetingDispatchContext } from '../CreateEditMeetingsProvider';

const useStyles = makeStyles(() => ({
  label: {
    marginBottom: '6px',
  },
}));

const SubmittedProposals = ({ proposals }) => {
  const classes = useStyles();
  const dispatch = useContext(MeetingDispatchContext);

  const togglePoint = (id, selected, fromPool) => e => {
    e.preventDefault();
    dispatch({
      type: fromPool ? 'POINT_TO_POOL' : 'TOGGLE_PROPOSAL_POINT',
      payload: {
        id,
        value: !selected,
      },
    });
  };

  return (
    <>
      <Subtitle2 className={classes.label}>Propostas submetidas</Subtitle2>
      <TimeBox>
        <Subtitle2>
          {proposals.map((point, idx) => (
            <ListPointsCheckbox
              key={`${point.id || '_id_'}_${point.name}`}
              label={
                point.identifier_code ? `${point.identifier_code} - ${point.name}` : point.name
              }
              onClick={togglePoint(point.id, point.selected, point.fromPool)}
              checked={point.selected}
              divider={idx < proposals.length - 1}
            />
          ))}
        </Subtitle2>
      </TimeBox>
    </>
  );
};

SubmittedProposals.propTypes = {
  proposals: PropTypes.array.isRequired,
};

export default React.memo(SubmittedProposals);
